import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getSixthAnalyses = asyncThunkWrapper({ 
  model: 'sixthAnalyses', 
  action: 'getSixthAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', { inputs: ['id', 'filename'] }, 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/sixth_flow/sixth_analyses', { params });

    return response.data;
  } 
});
export const getSixthAnalysis = asyncThunkWrapper({ 
  model: 'sixthAnalyses', 
  action: 'getSixthAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = [
      'id', 
      { inputs: ['id', 'filename', 'content_type', 'url'] }, 
      { result: ['id', 'filename', 'content_type', 'url'] }, 
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/sixth_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const createSixthAnalysis = asyncThunkWrapper({ 
  model: 'sixthAnalyses', 
  action: 'createSixthAnalysis', 
  func: async (sixth_analysis) => {
    const attributes = ['id', { inputs: ['id', 'filename'] }, 'status', 'updated_at'];
    const response = await axios.post(`/sixth_flow/sixth_analyses`, { sixth_analysis, attributes });

    return response.data;
  } 
});
export const clearLocalSixthAnalyses = createAction('sixthAnalyses/clearLocalSixthAnalyses');
export const clearLocalActiveSixthAnalysis = createAction('sixthAnalyses/clearLocalActiveSixthAnalysis');